<template>
  <div>
    <!-- faq search section -->
    <section>
      <header-title
        title="الأسئلة الشائعة"
        titlePrevious="الرئيسية"
        color="#9499d0"
      />
      <!-- <div>الرئيسية</div> -->
    </section>
    <section id="faq-search-filter" class="">
      <b-card
        no-body
        class="faq-search"
        :style="{
          backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
        }"
      >
        <b-card-body class="text-center">
          <h2 class="text-primary">في حال كان لديك أي سؤال</h2>
          <b-card-text class="mb-2" style="margin-top: 20px">
            قم بالبحث أو أختر من القائمة على طرف اليمين
          </b-card-text>

          <!-- form -->
          <b-form class="faq-search-input">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="searchbar"
                v-model="faqSearchQuery"
                placeholder="ابحث عن سؤال ..."
              />
            </b-input-group>
          </b-form>
          <!-- form -->
        </b-card-body>
      </b-card>
    </section>
    <!--/ faq search section -->

    <!-- frequently asked questions tabs pills -->
    <section id="faq-tabs" class="container" v-if="faqSearchQuery == ''">
      <div v-if="loadingCat" class="d-flex w-100">
        <div class="w-25">
          <b-skeleton
            width="90%"
            height="40px"
            v-for="n in 4"
            :key="n"
          ></b-skeleton>
        </div>
        <div class="w-75">
          <b-skeleton
            width="90%"
            height="40px"
            v-for="n in 4"
            :key="n"
          ></b-skeleton>
        </div>
      </div>
      <b-tabs
        v-else
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >
        <!-- payment tab -->
        <b-tab
          v-for="(item, index) in categories"
          :key="item.id"
          :active="!index"
          @click="$store.dispatch(`NgoHome/faq/getQuestion`, { id: item.id })"
        >
          <!-- title -->
          <template #title>
            <!-- <feather-icon :icon="categoryObj.icon" size="18" class="mr-1" /> -->
            <span class="font-weight-bold">{{ item.name_ar }}</span>
          </template>

          <faq-question-answer :nameCat="item.name_ar" />
        </b-tab>
        <!--/ payment tab -->

        <!-- sitting lady image -->
        <template #tabs-end>
          <b-img
            fluid
            :src="require('@/assets/images/illustration/faq-illustrations.svg')"
            class="d-none d-md-block mt-auto"
          />
        </template>
        <!--/ sitting lady image -->
      </b-tabs>
    </section>
    <!--/ frequently asked questions tabs pills -->
    <section v-else class="container">
      <div v-if="loadingCat">
        <b-skeleton
          width="100%"
          height="40px"
          v-for="n in 4"
          :key="n"
        ></b-skeleton>
      </div>
      <faq-question-answer v-else />
    </section>
    <!-- contact us -->
    <section class="faq-contact container">
      <b-row class="mt-5 pt-75 text-center">
        <b-col cols="12">
          <h2>مايزال لديك سؤال؟</h2>
          <b-card-text class="mb-3" style="margin-top: 20px">
            يمكنك التواصل مع فريق الوزارة للإجابة على أسئلتك
          </b-card-text>
        </b-col>
        <b-col sm="6">
          <b-card class="shadow-none py-1 faq-contact-card">
            <b-avatar size="42" rounded variant="light-primary" class="mb-2">
              <feather-icon icon="PhoneCallIcon" size="18" />
            </b-avatar>
            <h4>00963-112314151 </h4>
          </b-card>
        </b-col>
        <b-col sm="6">
          <b-card class="shadow-none py-1 faq-contact-card">
            <b-avatar size="42" rounded variant="light-primary" class="mb-2">
              <feather-icon icon="MailIcon" size="18" />
            </b-avatar>
            <h4>info@ngo.gov.sy</h4>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section></section>
    <!--/ contact us -->
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BForm,
  BInputGroup,
  BFormInput,
  BCardText,
  BInputGroupPrepend,
  BTabs,
  BTab,
  BImg,
  BRow,
  BCol,
  BAvatar,
  BSkeleton,
} from "bootstrap-vue";
import FaqQuestionAnswer from "../../components/FaqQuestionAnswer.vue";
import HeaderTitle from "../../components/HeaderTitle.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BAvatar,
    BCardBody,
    BInputGroup,
    BFormInput,
    BCardText,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BImg,
    FaqQuestionAnswer,
    HeaderTitle,
    BSkeleton,
  },
  data() {
    return {
      faqSearchQuery: "",
    };
  },
  methods: {
    filtered(value) {
      this.$store.dispatch(`NgoHome/faq/filteredQuestion`, {
        filter_question: value,
      });
    },
  },
  watch: {
    faqSearchQuery(value) {
      this.filtered(value);
    },
  },
  computed: {
    ...mapGetters("NgoHome/faq", [
      "question",
      "categories",
      "loading",
      "loadingCat",
    ]),
  },
  created() {
    this.$store.dispatch(`NgoHome/faq/getCategories`);
    this.$store.dispatch(`NgoHome/faq/getQuestion`, { id: 1 });
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-faq.scss";
</style>
